import React from "react";
import SummaryItem from "../../components/SummaryItem";
import { useRecoilState } from "recoil";
import { vehicleDetailsState } from "../../state/QuoteState";
import CustomDivider from "../../components/CustomDivider";

const VehicleDetailsSummary = ({ onEdit }: { onEdit: () => void }) => {
  const [
    {
      vehicleYear,
      make,
      model,
      modelDetails,
      hasMMCode,
      mmCode,
      color,
      typeOfUse,
      vehicleStatus,
    },
  ] = useRecoilState(vehicleDetailsState);
  return (
    <>
      <SummaryItem
        items={
          hasMMCode
            ? [vehicleYear, mmCode]
            : [vehicleYear, make, model, modelDetails]
        }
        onEdit={onEdit}
      >
        Vehicle
      </SummaryItem>
      <CustomDivider />
      <SummaryItem items={[color]} onEdit={onEdit}>
        Exterior
      </SummaryItem>
      <CustomDivider />
      <SummaryItem items={[typeOfUse]} onEdit={onEdit}>
        Vehicle use
      </SummaryItem>
      <CustomDivider />
      <SummaryItem items={[vehicleStatus ? "New" : "Used"]} onEdit={onEdit}>
        Vehicle status
      </SummaryItem>
    </>
  );
};

export default VehicleDetailsSummary;
